import { render, staticRenderFns } from "./student-opportunity-list.vue?vue&type=template&id=00444680&scoped=true&"
import script from "./student-opportunity-list.vue?vue&type=script&lang=js&"
export * from "./student-opportunity-list.vue?vue&type=script&lang=js&"
import style0 from "./student-opportunity-list.vue?vue&type=style&index=0&id=00444680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00444680",
  null
  
)

component.options.__file = "student-opportunity-list.vue"
export default component.exports